/**
 * Получает ID группы объекта из текущего роута
 */
export const getGroupIdFromRoute = (route) => {
  const groupId = route.params?.groupId;

  if (!groupId) return null;

  return parseInt(groupId, 10);
};